import { Permission } from '@cims-online/shared'
import { CIMSTabs } from 'components/CIMSTabs'
import { useCheckPermission } from 'hooks/useCheckPermission'
import LabTechSelectProvider from 'components/CIMSSelect/common/LabTechSelect/LabTechSelectContext'
import LabTechs from './components/LabTechs'
import TestingLabs from './components/TestingLabs'
import TestingLabsProvider from './components/TestingLabs/TestingLabsContext'
import LabTechsProvider from './components/LabTechs/LabTechsContext'
import UserSelectProvider from 'components/CIMSSelect/common/UserSelect/UserSelectContext'
import TestingLabSelectProvider from 'components/CIMSSelect/common/TestingLabSelect/TestingLabSelectContext'

const TestingLabsTabs: React.FC = () => {
  const allTestingLabPermissions = [
    Permission.CreateTestingLab,
    Permission.RemoveTestingLab,
    Permission.EditAllTestingLab,
    Permission.EditLimitedTestingLab,
    Permission.ViewTestingLab,
  ]
  const canAccessTestingLabs = useCheckPermission(allTestingLabPermissions)
  const canAccessLabTechs = useCheckPermission([
    Permission.CreateLabTech,
    Permission.RemoveLabTech,
    Permission.ViewLabTech,
    ...allTestingLabPermissions,
  ])
  const Tab = { TestingLabs: 'Testing Labs', LabTechs: 'Lab Techs' } as const
  return (
    <CIMSTabs
      initialTab={canAccessTestingLabs ? Tab.TestingLabs : Tab.LabTechs}
      tabs={[
        {
          label: Tab.TestingLabs,
          permission: canAccessTestingLabs,
          key: Tab.TestingLabs,
          component: (
            <LabTechSelectProvider>
              <TestingLabsProvider>
                <TestingLabs />
              </TestingLabsProvider>
            </LabTechSelectProvider>
          ),
        },
        {
          label: Tab.LabTechs,
          permission: canAccessLabTechs,
          key: Tab.LabTechs,
          component: (
            <UserSelectProvider>
              <TestingLabSelectProvider>
                <LabTechsProvider>
                  <LabTechs />
                </LabTechsProvider>
              </TestingLabSelectProvider>
            </UserSelectProvider>
          ),
        },
      ]}
    />
  )
}

export default TestingLabsTabs
